export const formatTimesPerDay = (timesPerDay: number) => {
  return timesPerDay === 1 ? '1 tillfälle per dag' : `${timesPerDay} tillfällen per dag`
}
